import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation, Trans } from 'react-i18next';
import Container from '../../components/shared/atoms/Container';
import Box from '../../components/shared/atoms/Box';
import Heading from '../../components/shared/atoms/Heading';
import TakeCare from '../../components/giftcard/landingGiftcard/TakeCare';
import ASmartGift from '../../components/giftcard/landingGiftcard/ASmartGift';
import PersonalizeYourGiftcard from '../../components/giftcard/landingGiftcard/PersonalizeYourGiftcard';
import ReallyUseful from '../../components/giftcard/landingGiftcard/ReallyUseful';
import WhoIsYourFriend from '../../components/giftcard/landingGiftcard/WhoIsYourFriend';
import ButtonsWithPop from '../../components/giftcard/landingGiftcard/ButtonsWithPop';
import { Content } from '../../components/shared/organisms/HowItWorks';
import Separator from '../../components/Separator';
import WeTellYouEverything from '../../components/shared/molecules/WeTellYouEverything';
import WeFixEverywhere from '../../components/home/WeFixEverywhere';

const LandingGiftCard = () => {
  const { t } = useTranslation();
  return (
    <Container fluid overflowHide={true}>
      <Helmet
        title="Carte Cadeau Réparation Vélo : +10% de Bonus"
        meta={[
          {
            name: 'description',
            content:
              "Offrez la carte cadeau vélo avec +10% de bonus : utilisable toute l'année sur réparations à domicile. Le cadeau malin pour cyclistes !",
          },
          { name: 'twitter:card', content: 'summary_large_image' },
          {
            name: 'twitter:title',
            content: 'Carte Cadeau Réparation Vélo : +10% de Bonus',
          },
          {
            name: 'twitter:description',
            content:
              "Offrez la carte cadeau vélo avec +10% de bonus : utilisable toute l'année sur réparations à domicile.",
          },
          {
            name: 'twitter:image',
            content:
              'https://uploads-ssl.webflow.com/664e20aae5145eb7a61de885/666854745cce5ad6c682189f_Re%CC%81parer%20son%20ve%CC%81lo%20devient%20un%20jeu%20d%E2%80%99enfant.png',
          },
        ]}
      />
      <Heading textAlign="center" level={1} mt={9}>
        <Trans
          i18nKey="giftcardlanding.heading"
          components={{ textgradiant: <span style={{ color: '#595FE7' }} /> }}
        />
      </Heading>
      <Box display="flex" justifyContent="center" mt={3}>
        <div className="bonusrepar-banner">
          <p className="a-paragraph-regular white">
            🎁 +10% offerts : vous achetez 50€, votre ami reçoit{' '}
            <span className="text-span-125">55€</span>!
          </p>
        </div>
      </Box>
      <TakeCare />
      <Container pt="40px">
        <ASmartGift />
      </Container>
      <PersonalizeYourGiftcard />
      <ReallyUseful />
      <Container>
        <WhoIsYourFriend />
      </Container>
      <Box my={100}>
        <ButtonsWithPop />
      </Box>
      <WeFixEverywhere
        bg="gray.lightest"
        mapHasBackground={false}
        borderRadius="md"
        giftcard
        py={7}
      />
      <Container>
        <Separator axe="horizontal" my={9} />
        <Content title={t('howitworks')} t={t} />
        <Separator axe="horizontal" my={9} />
      </Container>
      <WeTellYouEverything
        giftcard
        values={[
          {
            title: t('giftcard.questions.1'),
            text: <span>{t('giftcard.answers.1')}</span>,
          },
          {
            title: t('giftcard.questions.2'),
            text: t('giftcard.answers.2'),
          },
          {
            title: t('giftcard.questions.3'),
            text: t('giftcard.answers.3'),
          },
          {
            title: <span>{t('giftcard.questions.4')}</span>,
            text: t('giftcard.answers.4'),
          },
          {
            title: <span>{t('giftcard.questions.5')}</span>,
            text: t('giftcard.answers.5'),
          },
          {
            title: <span>{t('giftcard.questions.6')}</span>,
            text: t('giftcard.answers.6'),
          },
          {
            title: <span>{t('giftcard.questions.7')}</span>,
            text: t('giftcard.answers.7'),
          },
        ]}
      />
    </Container>
  );
};
export default LandingGiftCard;
